<template>
  <div class="flex flex-wrap flex-row gap-2 justify-center">
    <survey-answer-button
      v-for="answer in question.answers"
      :key="answer.value.toString()"
      :style="{'background-color': answer?.color}"
      @click="onPress(answer.value)"
    >
      <span
        class="font-content"
        :style="{'color': answer?.color ? 'white' : 'black'}"
      >
        {{ answer.label }}
      </span>
    </survey-answer-button>
  </div>
</template>

<script lang="ts" setup>
/**
 * Survey answer component for single choice questions.
 *
 * It displays a list of answer buttons, allowing the user to select one option.
 * When an answer is selected, it emits the 'onPress' event with the selected answer's value.
 */

import SurveyAnswerButton from '@/survey/components/survey-modal/answers/SurveyAnswerButton.vue';
import {SingleChoiceSurveyQuestion} from "@/core/interfaces/survey/Survey";
import {SurveyAnswerComponentEmit, SurveyAnswerComponentProps} from "@/survey/components/survey-modal/answers/index";

defineProps<SurveyAnswerComponentProps<SingleChoiceSurveyQuestion>>();
const emits = defineEmits<SurveyAnswerComponentEmit<SingleChoiceSurveyQuestion>>();

const onPress = (id: number | string | boolean) => {
    emits('onPress', {value: [id]});
};
</script>
